module.exports = __webpack_public_path__ + "media/images/contact/WS-antoine-e92b7fc9d629b9d0f8d947f3c97fe907.jpg";